














































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import VCard from "@/components/VCard.vue";
import formatNumber from "@/filters/FormatNumber";

export type MediumCardGroup = {
  id: string;
  name: string;
  items: MediumCardItem[];
};

export type MediumCardItem = {
  icon: string | null;
  id: string;
  text: string;
  budget: number;
  count: number;
};

@Component({ components: { VCard }, filters: { formatNumber } })
export default class MediumCard extends Vue {
  @Prop({ required: true }) readonly groups!: MediumCardGroup[];
  @Prop({ required: true }) readonly title!: string;
  @Prop({ default: false }) readonly clickable!: boolean;

  onClick(item: MediumCardItem, group: MediumCardGroup) {
    if (this.clickable) {
      this.$emit("click", item, group);
    }
  }
}
